<template>
  <NotificationTemplate
    :notification="notification"
    :projectName="notification.projectName"
    :showSubTitle="false"
    class="notification__item"
  >
    <template #pic>
      <div class="label-pic is-green">
        <icon
          data="@icon/folder.svg"
          class="label-pic__icon"
          width="20px"
          height="19px"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        Backlog imported
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__update-item__description"
      >
        Backlog import from Jira is complete
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import { Prop } from "vue-property-decorator"
import { Notification } from "@/models/Notification"

@Options({
  name: "JIRA_BACKLOG_IMPORT_COMPLETED",
  components: {
    NotificationTemplate,
  },
})
export default class JIRA_BACKLOG_IMPORT_COMPLETED extends Vue {
  @Prop() readonly notification: Notification
}
</script>
